import { managerApi } from "api/managerApi";
import { utilsModule } from "../../utils-module";

function passwordResetController($scope, $q, UserIdha, History, dialogs, $translate) {
    let ctrl = this;

    this.MIN_PASSWORD_SIZE = 6;
    this.emailOrPhone = null
    this.validated = false;
    this.user = {};
    this.state = 'SEND_VERIFICATION_CODE'
    this.verificationCode = undefined
    this.temporaryAccessToken = undefined

    this.isEmail = function (data) {
        const emailRegex = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
        return emailRegex.test(data);
    }

   

    this.goBack = function () {
        History.back(null, 'app.html');
    }

    this.resetPassword = async function () {
        try {
            
            

            if (ctrl.isEmail(ctrl.emailOrPhone)) {
                await managerApi.UserIdha.confirmEmail(ctrl.emailOrPhone)
            } else {
                await managerApi.UserIdha.confirmPhone(ctrl.emailOrPhone)
            }
            
            this.state = "INFORM_VERIFICATION_CODE"
            

        } catch (err) {
            if (err.data && err.data.error) {
                if (err.data.error.code == "RESET_FAILED_EMAIL_NOT_VERIFIED") {
                    dialogs.error($translate.instant("EMAIL_NOT_VERIFIED"));
                    return;
                }
            }

            if (err.customMsg) {
                dialogs.error(err.customMsg)
            } else {
                dialogs.error($translate.instant("FAIL_PASSWORD_RESET"))
            }
        }


    }

    this.checkVerificationCode = async function() {
        const response = await managerApi.UserIdha.verifyIdentityData({
            emailValidationToken: ctrl.isEmail(ctrl.emailOrPhone) ?  ctrl.verificationCode : undefined,
            phoneValidationToken: !ctrl.isEmail(ctrl.emailOrPhone) ?  ctrl.verificationCode : undefined,
            emailOrPhone: ctrl.emailOrPhone,
            generateTemporaryAccessToken: true
        })

        if ((ctrl.isEmail(ctrl.emailOrPhone) && response.emailVerified) || 
            (!ctrl.isEmail(ctrl.emailOrPhone) && response.phoneVerified)) {
            ctrl.temporaryAccessToken = response.temporaryAccessToken
            ctrl.state = 'INFORM_NEW_PASSWORD'
        } else {
            dialogs.error($translate.instant("INVALID_VERIFICATION_CODE"))
        }
    }

    this.changePassword = async function() {

        ctrl.validated = true

        if ($scope.formId.$invalid) {
            alert('Verifique os dados informados')
            return
        }
        
        await managerApi.UserIdha.forceChangePassword({
            newPassword: ctrl.newPassword
        }, {
            headers: {
                Authorization: ctrl.temporaryAccessToken
            }
        })

        ctrl.onBackToLoginClick()
    }
}

utilsModule.component('passwordReset', {
    template: require('./password-reset.component.html'),
    controller: ['$scope', '$q', 'UserIdha', 'History', 'dialogs', '$translate', passwordResetController],
    bindings: {
        onBackToLoginClick: '&'
    }
})